<template>
  <div class="zoom-controls is-hidden-mobile is-flex">
    <span @click="zoomOut" class="zoom-out zoom-btn is-flex" aria-label="Zoom Out" :data-balloon="$t('magicboard.zoomOut')" data-balloon-pos="up">
      <i class="fal fa-search-minus" aria-hidden="true"></i>
    </span>
    <span @click="reset" class="reset zoom-btn is-flex" aria-label="Fit" :data-balloon="$t('magicboard.fit')" data-balloon-pos="up">{{ $t('magicboard.fit') }}</span>
    <span @click="zoomIn" class="zoom-in zoom-btn is-flex" aria-label="Zoom In" :data-balloon="$t('magicboard.zoomIn')" data-balloon-pos="up">
      <i class="fal fa-search-plus" aria-hidden="true"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: ['callback'],
  methods: {
    zoomIn: function (event) {
      this.callback({ in: true }, event)
    },
    zoomOut: function (event) {
      this.callback({ out: true }, event)
    },
    reset: function (event) {
      this.callback({ reset: true }, event)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .zoom-controls {
    justify-content: center;
    width: 27%;
    padding: 0 0.3rem;
    @include touch {
      width: 33%;
    }
    @include mobile {
      display: none;
    }
    cursor: pointer;
    span {
      padding: 0.3rem;
    }
    .reset {
      font-size: 0.8rem;
    }
    .zoom-btn {
      background-color: #F0F0F0;
      height: 55px;
      width: 55px;
      margin: 0 0.5rem;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      @include touch {
        margin: 0 0.25rem;
      }
      &:hover,
      &:focus {
        color: $primary;
      }
    }
  }
</style>
